import { defineStore } from "pinia";
import { rootGetters } from "@/main";

const endpoints = {
  getSegmentCosts: { method: "get", url: "/segments/costs" },
};

export const useStatisticsStore = defineStore("statistics", {
  state: () => ({
    statisticsData: {
      statistics: {
        total_cost: 0,
        total_users: 0,
        segments_count: 0,
      },
      items: [] as StatisticsItem[],
    },
    itemsPerPage: 20,
    itemsCount: 0,
    activeFirst: false,
  }),
  getters: {
    items: (state) => state.statisticsData.items,
    statistics: (state) => state.statisticsData.statistics,
    itemsPagesCount: (state) => {
      return Math.ceil(state.itemsCount / state.itemsPerPage);
    },
  },
  actions: {
    async getSegmentCosts(params: StatisticsParams = { page: 1, per_page: 20 }) {
      await rootGetters.api
        .proceedRequest(endpoints.getSegmentCosts, {}, params)
        .then((response) => {
          this.statisticsData = response.data;
          if (this.statisticsData.items) {
            this.itemsPerPage = parseInt(response.headers["x-per-page"] || "20");
            this.itemsCount = parseInt(response.headers["x-total-count"] || "0");
          }
        });
    },
  },
});


export interface DateRange {
  start_date: Date | null;
  end_date: Date | null;
}

export interface StatisticsParams {
  page?: number;
  per_page?: number;
  order_by?: string | null;
  cdate?: string | null;
  mdate?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  campaign_segment_state_id__in?: string | null;
  brand_pk__in?: string | null;
  ads_cabinet_id__in?: string | null;
  segment_id__in?: string | null;
  source_slug__in?: string | null;
}

export interface StatisticsFilter {
  brand: string[];
  segment: number[];
  ads_cabinet: number[];
  date: DateRange | null;
  state: number[];
  platform: string[];
}

export interface StatisticsResponse {
  statistics: {
    total_cost: number;
    total_users: number;
    segments_count: number;
  };
  items: StatisticsItem[];
}

export interface StatisticsItem {
  campaign: {
    id: number;
    name: string;
    brand_pk: string;
  } | null;
  segment: {
    id: number;
    name: string;
    tenant?: string | null;
  } | null;
  segment_rich: {
    id: number;
    segment_id: number;
    rich: number;
    cost: number;
    ts: string;
  } | null;
  campaign_segment_rich: {
    id: number;
    campaign_segment_id: number;
    rich: number;
    ts: string;
  } | null;
  platform_segment_state: {
    id: number;
    platform_state: string;
    platform_slug: string;
  } | null;
  campaign_segment_state: {
    id: number;
    name: string;
    display_name: string;
  } | null;
  ads_cabinet: {
    id: number;
    name: string;
    external_id: string;
  } | null;
  source_segment_id: number;
  segment_cost: number;
  ctime: string;
}

